var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPsychicMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.75 11.5C3.23324 11.5 3.67075 11.3041 3.98743 10.9874C4.30412 10.6707 4.5 10.2332 4.5 9.75C4.5 9.26675 4.30412 8.82925 3.98743 8.51256C3.67075 8.19588 3.23324 8 2.75 8C2.26675 8 1.82925 8.19588 1.51256 8.51256C1.19588 8.82925 1 9.26675 1 9.75C1 10.2332 1.19588 10.6707 1.51256 10.9874C1.82925 11.3041 2.26675 11.5 2.75 11.5Z",
    fill: "#292A3F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25 11.5C9.73324 11.5 10.1707 11.3041 10.4874 10.9874C10.8041 10.6707 11 10.2332 11 9.75C11 9.26675 10.8041 8.82925 10.4874 8.51256C10.1707 8.19588 9.73324 8 9.25 8C8.76675 8 8.32925 8.19588 8.01256 8.51256C7.69588 8.82925 7.5 9.26675 7.5 9.75C7.5 10.2332 7.69588 10.6707 8.01256 10.9874C8.32925 11.3041 8.76675 11.5 9.25 11.5Z",
    fill: "#292A3F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 11.5C16.2332 11.5 16.6707 11.3041 16.9874 10.9874C17.3041 10.6707 17.5 10.2332 17.5 9.75C17.5 9.26675 17.3041 8.82925 16.9874 8.51256C16.6707 8.19588 16.2332 8 15.75 8C15.2668 8 14.8293 8.19588 14.5126 8.51256C14.1959 8.82925 14 9.26675 14 9.75C14 10.2332 14.1959 10.6707 14.5126 10.9874C14.8293 11.3041 15.2668 11.5 15.75 11.5Z",
    fill: "#292A3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPsychicMore);
export default __webpack_public_path__ + "static/media/icon_psychic_more.1cb808ca5819ff9cee23e589ca59de52.svg";
export { ForwardRef as ReactComponent };